'use client';
import { twJoin } from 'tailwind-merge';
import { FC, useState } from 'react';
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from '@headlessui/react';

import { Svg } from '@/components';
import { ChevronDownIcon } from '@/icons';

export type OptionTypes = {
  index: string;
  label: string;
  value: string;
  sku: string;
};

export interface PropTypes {
  options: Array<OptionTypes> | [];
  defaultValue?: string;
  getSelected?: (...args: any) => void;
  sku: string;
}

const SelectOptionProductCard: FC<PropTypes> = ({
  options = [],
  defaultValue = options[0]?.value,
  getSelected,
}) => {
  const [selectedPackageOption, selectPackageOption] = useState<any>(
    defaultValue || null
  );

  const onOptionChange = (option: OptionTypes) => {
    if (getSelected) {
      getSelected({ ...option });
    }
    selectPackageOption({ label: option.label, value: option?.value });
  };

  if (selectedPackageOption) {
    return (
      <div aria-label='options' className='relative'>
        <Listbox
          value={selectedPackageOption}
          onChange={onOptionChange}
          by='value'>
          <ListboxButton className='flex items-center gap-2 text-sm text-black/60'>
            {selectedPackageOption?.label}
            <Svg viewBox='0 0 16 16' className='h-3 w-3'>
              <ChevronDownIcon />
            </Svg>
          </ListboxButton>
          <ListboxOptions
            className='absolute right-0 top-6 z-10 h-max max-h-22 w-max overflow-y-scroll rounded-md border border-fig bg-pale-rose'
            as='ul'>
            {options?.map((option: OptionTypes, index: number) => (
              <ListboxOption
                value={{ ...option, index }}
                key={option?.value}
                as='li'
                className={({ active, selected }) =>
                  twJoin(
                    `w-full cursor-pointer px-3 py-2 text-sm hover:bg-fig/10 hover:text-fig`,
                    active || selected ? 'bg-fig/10 text-fig' : ''
                  )
                }>
                {option?.label}
              </ListboxOption>
            ))}
          </ListboxOptions>
        </Listbox>
      </div>
    );
  }

  return <div className='base-loading ' />;
};

export default SelectOptionProductCard;
